<template>
  <svg
    id="svg--healthcare"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path d="M18 1l-6 4-6-4-6 5v7l12 10 12-10v-7z" />
  </svg>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
#svg--healthcare {
  animation: pulse 3s infinite;
  fill: #fa6940;

  height: 100%;
  width: 100%;
  max-width: 17em;
  padding: 1em;
}

@keyframes pulse {
  15% {
    transform: scale(1);
  }
  20% {
    transform: scale(1.2);
  }
  25% {
    transform: scale(1);
  }
  30% {
    transform: scale(1.2);
  }
  35% {
    transform: scale(1);
  }
}

@media only screen and (max-width: 500px) {
  #svg--healthcare {
    max-width: 100%;
    height: 17em;
  }
}
</style>
